import { Checkbox } from "@mui/material";
import { ReactComponent as CheckboxCheckedIcon } from "../assets/Icons/checkbox-checked.svg";
import { ReactComponent as CheckboxIcon } from "../assets/Icons/checkbox.svg";

const GKCheckbox = (props) => {
  return (
    <Checkbox
      {...props}
      icon={<CheckboxIcon />}
      checkedIcon={<CheckboxCheckedIcon />}
    />
  );
};

export default GKCheckbox;
